// extracted by mini-css-extract-plugin
export default {"taglistItem":"checkablePill_taglistItem__rTEb5","active":"checkablePill_active__Olvir"};